export default "__VITE_ASSET__DguHt5Y9__"